import React from "react";
import CategoryPage from "./CategoryPage";

function Organisational({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Organisational"
      parentCategory="News"
      posts={posts}
      publications={publications}
    />
  );

}

export default Organisational;